import { LookInfo } from "../handlers/types";
import {
  UPGRADE_TRANSLATION_KEYS,
  WEEKLY_UPGRADE_TRANSLATION_KEYS,
} from "../configs/upgradeTranslationKeys";

/**
 * Get the primary upgrade description for a look
 * @param look The look info object
 * @param t Translation function
 * @returns The translated upgrade description or fallback text
 */
export function getLookUpgradeDescription(
  look: LookInfo | null,
  t: (key: string, options?: any) => string
): string {
  if (!look) {
    return t("looks.noUpgrades", { defaultValue: "Just regular guy" });
  }

  const characteristicUpgrades = look.characteristicsUpgrades || {};
  const entries = Object.entries(characteristicUpgrades);

  if (entries.length === 0) {
    return t("looks.noUpgrades", { defaultValue: "Just regular guy" });
  }

  // Find the first significant upgrade or fallback to the first one
  for (const [key, value] of entries) {
    if (value !== undefined && UPGRADE_TRANSLATION_KEYS[key]) {
      return t(UPGRADE_TRANSLATION_KEYS[key], {
        defaultValue: key.charAt(0).toUpperCase() + key.slice(1),
      });
    }
  }

  // Fallback to first upgrade if none of the significant ones are found
  const [key, value] = entries[0];
  return value > 0
    ? `+${value} ${key}`
    : t("looks.noUpgrades", { defaultValue: "Just regular guy" });
}

/**
 * Get the primary upgrade description for a weekly sale look (uses "even more" variants)
 * @param look The look info object
 * @param t Translation function
 * @returns The translated upgrade description or fallback text
 */
export function getWeeklyLookUpgradeDescription(
  look: LookInfo | null,
  t: (key: string, options?: any) => string
): string {
  if (!look) {
    return t("looks.noUpgrades", { defaultValue: "Just regular guy" });
  }

  const characteristicUpgrades = look.characteristicsUpgrades || {};
  const entries = Object.entries(characteristicUpgrades);

  if (entries.length === 0) {
    return t("looks.noUpgrades", { defaultValue: "Just regular guy" });
  }

  // Find the first significant upgrade or fallback to the first one
  for (const [key, value] of entries) {
    if (value !== undefined && WEEKLY_UPGRADE_TRANSLATION_KEYS[key]) {
      return t(WEEKLY_UPGRADE_TRANSLATION_KEYS[key], {
        defaultValue: key.charAt(0).toUpperCase() + key.slice(1),
      });
    }
  }

  // Fallback to first upgrade if none of the significant ones are found
  const [key, value] = entries[0];
  return value > 0
    ? `+${value} ${key}`
    : t("looks.noUpgrades", { defaultValue: "Just regular guy" });
}
